import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import AddOnManager from "AddOnManager";

export default store => ({
  path: "managePrograms",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "administrator-tooling" */ "Tooling/routes/ManageProgrammes/ManageProgrammes"
      ),
      import(
        /* webpackChunkName: "administrator-tooling" */ "Tooling/modules/ToolingModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "tooling",
          reducer,
        });
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [AddOnManager(store)],
});
